"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const UI_1 = require("~/components/UI");
const consts_1 = require("~/store/account/consts");
const selectors_1 = require("~/store/selectors");
const events_1 = require("~/utils/events");
const pdfCustomizationUtils_1 = require("~/utils/pdfCustomizationUtils");
const utils_1 = require("~/utils/utils");
const redux_1 = require("redux");
const actions_1 = require("~/store/widgets/content/actions");
const consts_2 = require("~/consts/consts");
const types_1 = require("./types");
const PdfCustomizationModal_scss_1 = __importDefault(require("./PdfCustomizationModal.scss"));
function PdfCustomizationModal({ isImperialMeasurement, revisionNumber, explosionCoefficient, }) {
    var _a, _b, _c, _d, _e;
    const { t } = (0, react_i18next_1.useTranslation)('pdf');
    const user = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUser);
    const { bom } = (0, react_redux_1.useSelector)(selectors_1.selectBOM);
    const currentProject = (0, react_redux_1.useSelector)(selectors_1.selectCurrentProject);
    const isPdfExporting = (0, react_redux_1.useSelector)(selectors_1.selectBOMExporting);
    const discount = bom === null || bom === void 0 ? void 0 : bom.discount;
    const projectUserType = (_b = (_a = currentProject === null || currentProject === void 0 ? void 0 : currentProject.user) === null || _a === void 0 ? void 0 : _a.userType) === null || _b === void 0 ? void 0 : _b.name;
    const isUserRoleAdmin = ((_c = user === null || user === void 0 ? void 0 : user.userType) === null || _c === void 0 ? void 0 : _c.name) === consts_1.UserRoles.admin;
    const isUserRoleDistributor = ((_d = user === null || user === void 0 ? void 0 : user.userType) === null || _d === void 0 ? void 0 : _d.name) === consts_1.UserRoles.distributor;
    const isUserRoleCustomer = ((_e = user === null || user === void 0 ? void 0 : user.userType) === null || _e === void 0 ? void 0 : _e.name) === consts_1.UserRoles.customer;
    const isSpecialAgreementDiscountType = (discount === null || discount === void 0 ? void 0 : discount.type) === consts_2.DISCOUNT_TYPE.SPECIAL_PRICE_AGREEMENT;
    const isDiscountApplicable = (discount === null || discount === void 0 ? void 0 : discount.type) === consts_2.DISCOUNT_TYPE.DISTRIBUTOR || isSpecialAgreementDiscountType;
    const showCustomerPrice = isUserRoleDistributor && (!!(currentProject === null || currentProject === void 0 ? void 0 : currentProject.customer) || projectUserType === consts_1.UserRoles.customer);
    const showMyPrice = isUserRoleDistributor && discount && isDiscountApplicable;
    const showDistributorPrice = isUserRoleAdmin && discount && isDiscountApplicable;
    const showDiscountedPrice = isUserRoleCustomer && discount && (discount === null || discount === void 0 ? void 0 : discount.type) === consts_2.DISCOUNT_TYPE.CUSTOMER;
    const [selectedPriceOptionValue, setSelectedPriceOptionValue] = (0, react_1.useState)(types_1.DEFAULT_PRICE_OPTION);
    const [pdfCustomizationOptions, setPdfCustomizationOptions] = (0, react_1.useState)({
        titlePage: { checked: true, disabled: false },
        bomTable: { checked: true, disabled: false },
        isometricView: { checked: true, disabled: false },
        explodedExtrusions: { checked: true, disabled: false },
        explodedComponents: { checked: true, disabled: false },
        projectDimensions: { checked: true, disabled: false },
        panels: { checked: true, disabled: false },
    });
    const isAtLeastOneCheckBoxSelected = Object.values(pdfCustomizationOptions).some((item) => item.checked);
    const { dispatchSetBOMExporting } = (0, redux_1.bindActionCreators)({
        dispatchSetBOMExporting: actions_1.setBOMExporting,
    }, (0, react_redux_1.useDispatch)());
    (0, react_1.useEffect)(() => {
        if (!(bom === null || bom === void 0 ? void 0 : bom.groups)) {
            return;
        }
        const bomInfo = (0, pdfCustomizationUtils_1.analyzeBomData)(bom.groups);
        setPdfCustomizationOptions((prevState) => (Object.assign(Object.assign({}, prevState), { explodedExtrusions: {
                checked: prevState.explodedExtrusions.checked && bomInfo.hasExtrusions,
                disabled: !bomInfo.hasExtrusions,
            }, explodedComponents: {
                checked: prevState.explodedComponents.checked && bomInfo.hasComponents,
                disabled: !bomInfo.hasComponents,
            }, panels: {
                checked: prevState.panels.checked && bomInfo.hasPanels,
                disabled: !bomInfo.hasPanels,
            } })));
    }, [bom === null || bom === void 0 ? void 0 : bom.groups]);
    const priceOptions = (0, react_1.useMemo)(() => {
        const options = [
            {
                id: types_1.PRICE_OPTIONS.LIST_PRICE,
                label: t('pdf-customization.price-options.list-price'),
                value: types_1.PRICE_OPTION_VALUES[types_1.PRICE_OPTIONS.LIST_PRICE],
            },
            {
                id: types_1.PRICE_OPTIONS.NO_PRICE,
                label: t('pdf-customization.price-options.no-price'),
                value: types_1.PRICE_OPTION_VALUES[types_1.PRICE_OPTIONS.NO_PRICE],
            },
        ];
        if (showDistributorPrice) {
            options.push({
                id: types_1.PRICE_OPTIONS.DISTRIBUTOR_PRICE,
                label: t('pdf-customization.price-options.distributor-price'),
                value: types_1.PRICE_OPTION_VALUES[types_1.PRICE_OPTIONS.DISTRIBUTOR_PRICE],
            });
        }
        if (showMyPrice) {
            options.push({
                id: types_1.PRICE_OPTIONS.MY_PRICE,
                label: t('pdf-customization.price-options.my-price'),
                value: types_1.PRICE_OPTION_VALUES[types_1.PRICE_OPTIONS.MY_PRICE],
            });
        }
        if (showCustomerPrice) {
            options.push({
                id: types_1.PRICE_OPTIONS.CUSTOMER_PRICE,
                label: t('pdf-customization.price-options.customer-price'),
                value: types_1.PRICE_OPTION_VALUES[types_1.PRICE_OPTIONS.CUSTOMER_PRICE],
            });
        }
        if (showDiscountedPrice) {
            options.push({
                id: types_1.PRICE_OPTIONS.DISCOUNTED_PRICE,
                label: t('pdf-customization.price-options.discounted-price'),
                value: types_1.PRICE_OPTION_VALUES[types_1.PRICE_OPTIONS.DISCOUNTED_PRICE],
            });
        }
        return options;
    }, [t, showDistributorPrice, showMyPrice, showCustomerPrice, showDiscountedPrice]);
    const selectedPriceOption = (0, react_1.useMemo)(() => {
        return priceOptions.find((option) => option.value === selectedPriceOptionValue) || priceOptions[0];
    }, [priceOptions, selectedPriceOptionValue]);
    const handlePriceOptionChange = (value) => {
        setSelectedPriceOptionValue(value);
    };
    const pdfCustomizationOptionToggle = (key) => {
        setPdfCustomizationOptions((prevState) => (Object.assign(Object.assign({}, prevState), { [key]: Object.assign(Object.assign({}, prevState[key]), { checked: !prevState[key].checked }) })));
    };
    const handleExport = () => __awaiter(this, void 0, void 0, function* () {
        try {
            if (!currentProject) {
                return;
            }
            (0, events_1.hideModal)();
            dispatchSetBOMExporting(true);
            const isPriceIncluded = selectedPriceOptionValue !== 'no-price';
            const exportAsCustomer = selectedPriceOptionValue === 'customer-price';
            const { titlePage, bomTable, isometricView, explodedExtrusions, explodedComponents, projectDimensions, panels } = pdfCustomizationOptions;
            const screenShotsOptions = {
                isometricView: isometricView.checked,
                explodedExtrusions: explodedExtrusions.checked,
                explodedComponents: explodedComponents.checked,
                projectDimensions: projectDimensions.checked,
                panels: panels.checked,
            };
            const screenShots = yield (0, utils_1.getScreenShots)(explosionCoefficient, screenShotsOptions);
            const customizationOptions = {
                isPriceIncluded,
                isBomIncluded: bomTable.checked,
                titlePage: titlePage.checked,
                isometricView: isometricView.checked,
                explodedExtrusions: explodedExtrusions.checked,
                explodedComponents: explodedComponents.checked,
                projectDimensions: projectDimensions.checked,
                panels: panels.checked,
                priceOption: selectedPriceOptionValue,
            };
            const baseOptions = {
                projectId: currentProject.id,
                screenShots,
                isImperialMeasurement,
                exportAsCustomer,
            };
            const response = yield (0, pdfCustomizationUtils_1.performPDFDownload)(baseOptions, customizationOptions);
            const blob = new Blob([response.data], {
                type: response.headers['content-type'],
            });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `TSLOTS_${revisionNumber === null || revisionNumber === void 0 ? void 0 : revisionNumber.replace('-', '_')}.pdf`;
            link.click();
        }
        catch (error) {
            (0, events_1.showNotification)({
                type: 'error',
                message: t('pdf-customization.error.pdf-downloading-failed'),
            });
        }
        finally {
            dispatchSetBOMExporting(false);
        }
    });
    return (react_1.default.createElement("div", { className: PdfCustomizationModal_scss_1.default.content, id: "my-custom-modal" },
        react_1.default.createElement("div", { className: PdfCustomizationModal_scss_1.default.container },
            react_1.default.createElement("header", null,
                react_1.default.createElement("div", { className: PdfCustomizationModal_scss_1.default.title }, t('pdf-customization.title')),
                react_1.default.createElement("div", { className: PdfCustomizationModal_scss_1.default.subtitle }, t('pdf-customization.subtitle'))),
            react_1.default.createElement("main", null,
                react_1.default.createElement("section", { className: PdfCustomizationModal_scss_1.default.section },
                    react_1.default.createElement("div", { className: PdfCustomizationModal_scss_1.default.dropdown },
                        react_1.default.createElement("div", { className: PdfCustomizationModal_scss_1.default.sectionLabel }, t('pdf-customization.select-pricing')),
                        react_1.default.createElement("div", { className: PdfCustomizationModal_scss_1.default.selectContainer },
                            react_1.default.createElement(UI_1.Select, { options: priceOptions, onChange: handlePriceOptionChange, selected: selectedPriceOption })))),
                react_1.default.createElement("section", { className: PdfCustomizationModal_scss_1.default.section },
                    react_1.default.createElement("div", { className: PdfCustomizationModal_scss_1.default.sectionLabel }, t('pdf-customization.select-sections')),
                    react_1.default.createElement("div", { className: PdfCustomizationModal_scss_1.default.checkboxList }, Object.entries(pdfCustomizationOptions).map(([key, { checked, disabled }]) => (react_1.default.createElement(UI_1.Checkbox, { key: key, label: t(`pdf-customization.sections.${types_1.sectionKeyToLabelKey[key]}`), checked: checked, disabled: disabled, onCheck: () => pdfCustomizationOptionToggle(key) })))))),
            react_1.default.createElement("footer", null,
                react_1.default.createElement(UI_1.Button, { onClick: events_1.hideModal, variant: "secondary" }, t('pdf-customization.cancel')),
                react_1.default.createElement(UI_1.Button, { onClick: handleExport, variant: "primary", disabled: !isAtLeastOneCheckBoxSelected, loading: isPdfExporting }, t('pdf-customization.export'))))));
}
exports.default = PdfCustomizationModal;
